<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="check-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-check"></div>
                    <div class="area-name">{{ $query_area(aid) }} <span class="player-name">{{ player }} </span></div>
                    <div class="rule-txt">
                        <p v-for="(item,index) in rule_text" :key="index"><em class="index">{{ index + 1 }}</em>{{ item }}</p>
                    </div>
                    <div class="result" v-if="!is_return">您<b>不符合</b>回归老玩家条件，可以去招募其他回归老玩家，完成任务拿奖励哦！</div>
                    <div class="result" v-else>您<b>符合</b>老玩家条件，快去完成任务领奖励吧！</div>
                    <div class="u-btn ok" @click="destroyElement"></div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'check_modal',
    data : function () {
        return {
            visible : false,
            rule_text : ['游戏等级需要≥11级',
            '最后一次登录在2021年12月10日之前，且最近一个月内没有登录过',
            '累积充值满足一定条件',
            '历史竞技局数≥50局',
            ],
            is_return : false,
            aid : 0,
            player : '',          
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
    }    
}
</script>

<style scoped>

@media screen and (min-device-width: 1025px){
    .check-modal{
        width: 469px;
        height: 456px;
        background-image: url(../../images/bg-modal-check.png);
    }

    .u-btn.close{
        top: 12px;
    }    

    .t-check{
        width: 234px;
        height: 33px;
        margin: 0 auto 20px;
        background-image: url(../../images/title-player-check.png);
    }

    .area-name{
        margin-bottom: 12px;
        color: #497e89;
        text-align: center;
    }

    .area-name .player-name{
        color: #44342a;
    }

    .check-modal .dialog-wrapper{
        padding: 40px 30px 0;
    }
    
    .rule-txt{
        width: 374px;
        height: 169px;
        margin: 0 auto;
        padding: 12px 24px 0;
        box-sizing: border-box;
        background-image: url(../../images/bg-check-rule.png);
    }

    .check-modal p{
        position: relative;
        color: #63544b;
        line-height: 1.6;
        padding-left: 40px;
        margin-bottom: 8px;
    }

    .check-modal p .index{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 27px;
        height: 27px;
        line-height: 27px;
        background-image: url(../../images/bg-index.png);
        color: #e6dac0;
        font-weight: 700;
        text-align: center;
    }

    .result{
        margin-top: 15px;
        text-align: center;
        color: #44342a;
    }

    .result b{
        color: #a2332f;
    }

    .u-btn.ok{
        width: 166px;
        height: 49px;
        margin: 25px auto 0;
        background-image: url(../../images/btn-ok.png);    
    }
    
    .u-btn.ok:hover{
        background-image: url(../../images/btn-ok_hover.png);   
    }
}

@media screen and (max-device-width: 1024px){
    .check-modal{
        width: 609px;
        height: 652px;
        background-image: url(../../images/m/bg-modal-check.png);
    }

    .t-check{
        width: 280px;
        height: 39px;
        margin: 0 auto 20px;
        background-image: url(../../images/m/title-player-check.png);
    }

    .area-name{
        margin-bottom: 12px;
        color: #497e89;
        text-align: center;
    }

    .area-name .player-name{
        color: #44342a;
    }    

    .check-modal .dialog-wrapper{
        padding: 40px 30px 0;
    }
    
    .rule-txt{
        width: 534px;
        height: 254px;
        margin: 0 auto;
        padding: 12px 24px 0;
        box-sizing: border-box;
        background-image: url(../../images/m/bg-check-rule.png);
    }

    .check-modal p{
        position: relative;
        color: #63544b;
        line-height: 1.6;
        padding-left: 50px;
        margin-bottom: 8px;
    }

    .check-modal p .index{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 43px;
        height: 43px;
        line-height: 43px;
        background-image: url(../../images/m/bg-index.png);
        color: #e6dac0;
        font-weight: 700;
        text-align: center;
    }

    .result{
        margin-top: 15px;
        text-align: center;
        color: #44342a;
    }

    .result b{
        color: #a2332f;
    }

    .u-btn.ok{
        width: 218px;
        height: 65px;
        margin: 25px auto 0;
        background-image: url(../../images/m/btn-ok.png);    
    }
}

</style>


// WEBPACK FOOTER //
// src/components/CheckModal/checkModal.vue